import { useMutation } from 'react-query';
import { UserAPI } from 'api/user';
import dispatchToast from 'helpers/dispatchToast';

export default function useAdminUpdateEmail() {
  return useMutation(
    UserAPI.adminUpdateEmail,
    {
      onSuccess: ({ message }, { email }) => {
        dispatchToast({ message, type: 'success' });
      },
    }
  );
}
